module.exports = __webpack_public_path__ + "static/media/Outline-100.9b3a3cf0.webp";